<div class="items">
  <span class="item">&copy; {{ currentYear }} Medical Home Network</span>
  <a class="item" href="{{ termsOfUseLink }}" target="_blank">Terms of Use</a>
  <a class="item" href="{{ privacyPolicyLink }}" target="_blank">Privacy Policy</a>
  <a class="item" href="{{ complianceLink }}" target="_blank">Compliance</a>
</div>

@if (releaseNumber) {
  <div class="text-nowrap">Build number: {{ releaseNumber }}</div>
}
